import React from "react";

interface Condition {
  condition: boolean;
  component: React.ReactNode;
}

interface ConditionalRendererProps {
  conditions: Condition[];
  fallback?: React.ReactNode;
}

export const ConditionalRenderer: React.FC<ConditionalRendererProps> = ({
  conditions,
  fallback = null,
}) => {
  const matchedCondition = conditions.find((cond) => cond.condition);

  return <>{matchedCondition ? matchedCondition.component : fallback}</>;
};
